import React, { useMemo } from "react";
import { AbsoluteFill, Img, staticFile } from "remotion";
import { Animated, Scale, Fade, Move } from "remotion-animated";

interface ModelCardStyle {
  entrance?: "zoomIn" | "bounce" | "floatIn";
  backgroundColor?: string;
}

interface ModelCardProps {
  /** 图片路径（相对于 public/） */
  imageSrc: string;
  /** 模型名称（不再在内部渲染，通过外部 Badge 组件展示） */
  modelName?: string;
  style: ModelCardStyle;
  durationInFrames: number;
}

/**
 * ModelCard — 模型截图卡片展示组件
 *
 * 在暗色背景上居中显示截图（contain 模式）。
 * 模型名称标签已分离到 Badge 组件，放在 VisualEffect 外部渲染，
 * 不受视觉特效影响。
 */
const ModelCard: React.FC<ModelCardProps> = ({
  imageSrc,
  style: s,
  durationInFrames,
}) => {
  const animations = useMemo(() => {
    const anims: any[] = [];
    switch (s.entrance) {
      case "zoomIn":
        anims.push(
          Scale({ by: 1, initial: 1.2, mass: 0.5, damping: 12, stiffness: 100 }),
          Fade({ to: 1, initial: 0 }),
        );
        break;
      case "bounce":
        anims.push(
          Scale({ by: 1, initial: 0.3, mass: 0.4, damping: 7, stiffness: 100 }),
          Fade({ to: 1, initial: 0 }),
        );
        break;
      case "floatIn":
        anims.push(
          Move({ y: 0, initialY: 60, mass: 0.6, damping: 18, stiffness: 60 }),
          Fade({ to: 1, initial: 0 }),
        );
        break;
    }
    return anims;
  }, [s.entrance]);

  return (
    <AbsoluteFill
      style={{
        backgroundColor: s.backgroundColor ?? "#0a0a0a",
      }}
    >
      {/* 图片区域：居中显示，contain 保持完整可见 */}
      <AbsoluteFill
        style={{
          justifyContent: "center",
          alignItems: "center",
          padding: 80,
        }}
      >
        <Animated
          animations={animations}
          absolute
          in={0}
          out={durationInFrames}
          style={{
            width: "100%",
            maxWidth: 700,
            height: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Img
            src={staticFile(imageSrc)}
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "70vh",
              objectFit: "contain",
              borderRadius: 12,
              boxShadow: "0 8px 40px rgba(0,0,0,0.6)",
            }}
          />
        </Animated>
      </AbsoluteFill>
    </AbsoluteFill>
  );
};

export default ModelCard;
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
